import { ReactElement, useEffect, useLayoutEffect, useRef } from "react";
import classNames from "classnames";
import {
  UiaButtonIcon,
  UiaTextBody,
  UiaTextSubheading,
  useUiContext,
} from "@rotorstudios/fe-ui";
import { gsap } from "@rotorstudios/fe-modules";
import { Button } from "@tmca/toyota-kit";

import UiaIconClose from "../../uiComponents/atoms/uiaIconClose/UiaIconClose";
import "./_UiMARCodeAvailabilityOverlay.scss";

type UiMARCodeAvailabilityOverlayProps = {
  className?: string;
  tTitle: string;
  tBody: string;
  tLabel: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  arIntentUrl?: string;
};

const UiMARCodeAvailabilityOverlay = ({
  className = "",
  tTitle,
  tBody,
  tLabel,
  open,
  setOpen,
  arIntentUrl = undefined,
}: UiMARCodeAvailabilityOverlayProps): ReactElement => {
  const { projectClass, breakpointActive } = useUiContext();
  const ARUnavailableOverlayRef = useRef<any>(null);
  const baseRef = useRef<any>(null);

  const popUpTimeline = useRef<GSAPTimeline>(
    gsap.timeline({
      defaults: {
        ease: "expo.out",
      },
    }),
  );

  const getClassName = () =>
    classNames(
      `${projectClass}_UiMARCodeAvailabilityOverlay`,
      className,
      breakpointActive,
    );

  useEffect(() => {
    if (open) {
      popUpTimeline.current.play();
    }
  }, [open]);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const tl = popUpTimeline.current;
      tl.add("start")
        .to(
          baseRef.current,
          {
            duration: 0.5,
            display: "flex",
            onReverseComplete: () => {
              setOpen(false);
            },
          },
          "start",
        )
        .from(
          ARUnavailableOverlayRef.current,
          {
            duration: 0.5,
            scale: 0,
            opacity: 0,
          },
          "start",
        )
        .reverse();
    }, baseRef);
    return () => {
      ctx?.revert();
    };
  }, [setOpen]);

  return (
    <div ref={baseRef} className={getClassName()}>
      <div
        ref={ARUnavailableOverlayRef}
        className={`${projectClass}_UiMARCodeAvailabilityOverlay_Wrapper`}
      >
        <UiaTextSubheading tText={tTitle} LARGE />
        <UiaTextBody tText={tBody} />
        {arIntentUrl ? (
          <Button
            variant="primary"
            component="a"
            rel="noopener noreferrer"
            href={arIntentUrl}
            target={"_blank"}
          >
            {tLabel}
          </Button>
        ) : (
          <Button variant="primary" onClick={() => popUpTimeline.current.reverse()}>
            {tLabel}
          </Button>
        )}
        <UiaButtonIcon
          icon={<UiaIconClose />}
          onClick={() => {
            popUpTimeline.current.reverse();
          }}
          circular
        />
      </div>
    </div>
  );
};

export default UiMARCodeAvailabilityOverlay;
